import { IconButton, Stack, Typography } from "@mui/material";
import FilledInput from "@mui/material/FilledInput";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import CachedIcon from "@mui/icons-material/Cached";

import { useEffect, useRef, useState } from "react";

type formProps = {
  value: string | null;
  label: string;
  id: string;
  type: string;
  dropdown?: Array<string>;
};
export default function ContactForm() {
  ///Captcha Code
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [userInput, setUserInput] = useState("");

  const [captchaText, setCaptchaText] = useState("");
  const canvasRef: any = useRef(null);

  const generateRandomChar = (min: number, max: number) =>
    String.fromCharCode(Math.floor(Math.random() * (max - min + 1) + min));

  const generateCaptchaText = () => {
    let captcha = "";
    for (let i = 0; i < 3; i++) {
      captcha += generateRandomChar(65, 90);
      captcha += generateRandomChar(97, 122);
      captcha += generateRandomChar(48, 57);
    }
    return captcha
      .split("")
      .sort(() => Math.random() - 0.5)
      .join("");
  };

  const drawCaptchaOnCanvas = (ctx: any, captcha: string) => {
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    const textColors = ["rgb(0,0,0)", "rgb(130,130,130)"];
    const letterSpace = 150 / captcha.length;
    for (let i = 0; i < captcha.length; i++) {
      const xInitialSpace = 25;
      ctx.font = "20px Roboto Mono";
      ctx.fillStyle = textColors[Math.floor(Math.random() * 2)];
      ctx.fillText(
        captcha[i],
        xInitialSpace + i * letterSpace,

        // Randomize Y position slightly
        Math.floor(Math.random() * 16 + 25),
        100
      );
    }
  };

  const initializeCaptcha = (ctx: any) => {
    setUserInput("");
    const newCaptcha = generateCaptchaText();
    setCaptchaText(newCaptcha);
    drawCaptchaOnCanvas(ctx, newCaptcha);
  };

  //form handling and data
  const [formData, setFormData] = useState<formProps[]>([
    { value: "", label: "Name", id: "first_name", type: "text" },
    { value: "", label: "Email Address", id: "email", type: "email" },
    { value: null, label: "Phone Number", id: "phone_number", type: "number" },
    { value: "", label: "City", id: "city", type: "text" },
    {
      value: "",
      label: "Course",
      id: "course",
      type: "dropdown",
      dropdown: ["Bpt", "Mpt"],
    },
    { value: "", label: "Message", id: "message", type: "text" },
  ]);

  const UpdateData = (val: any, i: string) => {
    var newInfo = [...formData];
    for (let z = 0; z < newInfo.length; z++) {
      if (newInfo[z].id == i) {
        newInfo[z].value = val;
      }
    }
    setFormData(newInfo);
    handleClose();
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    setOpen(false);
  };

  //main submit function
  const onSubmit = () => {
    let finalData: Array<{ [key: string]: string }> = [];
    let completionFlag: boolean = true;
    if (userInput === captchaText) {
      formData.forEach((data, i) => {
        if (data.value !== "" && data.value !== null) {
          finalData.push({
            [data.id]: data.value,
          });
        } else {
          completionFlag = false;
          return;
        }
      });

      if (completionFlag) {
        alert("Submission Successful");
      } else {
        alert("Incomplete Data");
      }
    } else {
      alert("Incorrect Captcha");
      const canvas: any = canvasRef.current;
      const ctx = canvas?.getContext("2d");
      initializeCaptcha(ctx);
    }
  };

  useEffect(() => {
    const canvas: any = canvasRef.current;
    const ctx = canvas?.getContext("2d");
    initializeCaptcha(ctx);
  }, []);
  return (
    <Paper
      elevation={3}
      sx={{
        backgroundColor: "secondary.main",
        width: "100%",
        borderRadius: "10px",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        component="form"
        sx={{
          "& > :not(style)": { m: 1 },
          p: { xs: 1, md: 3 },
        }}
        noValidate
        autoComplete="off"
      >
        <Typography variant="h5">Get In Touch</Typography>
        {formData.map(({ value, label, id, type, dropdown }, i) => (
          <>
            {type === "dropdown" ? (
              <>
                <ButtonGroup
                  sx={{ width: "100%" }}
                  variant="contained"
                  ref={anchorRef}
                  aria-label="Button group with a nested menu"
                >
                  <Button sx={{ width: "100%" }}>
                    {value === "" ? "Course" : value}
                  </Button>
                  <Button
                    size="small"
                    aria-controls={open ? "split-button-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                  >
                    <ArrowDropDownIcon />
                  </Button>
                </ButtonGroup>
                <Popper
                  sx={{
                    zIndex: 3,
                    backgroundColor: "primary.main",
                    width: { xs: "80%", md: "30%" },
                  }}
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom"
                            ? "center top"
                            : "center bottom",
                      }}
                    >
                      <Paper sx={{ width: "100%" }}>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList
                            id="split-button-menu"
                            autoFocusItem
                            sx={{
                              backgroundColor: "primary.main",
                              width: "100%",
                            }}
                          >
                            {dropdown?.map((option, index) => (
                              <MenuItem
                                key={option}
                                sx={{
                                  ":hover": {
                                    bgcolor: "secondary.main", // theme.palette.primary.main
                                    color: "text.secondary",
                                  },
                                }}
                                onClick={() => {
                                  UpdateData(option, id);
                                }}
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </>
            ) : (
              <FormControl variant="filled" sx={{ width: "100%" }}>
                <InputLabel htmlFor={id}>{label}</InputLabel>
                <FilledInput
                  defaultValue="Composed TextField"
                  id={id}
                  value={value}
                  type={type}
                  onChange={(e) => {
                    UpdateData(e.target.value, id);
                  }}
                />
              </FormControl>
            )}
          </>
        ))}
        <Stack direction={"row"}>
          <canvas ref={canvasRef} width="200" height="70"></canvas>
          <IconButton
            onClick={() =>
              initializeCaptcha(canvasRef.current?.getContext("2d"))
            }
          >
            <CachedIcon />
          </IconButton>
        </Stack>
        <FilledInput
          defaultValue="Composed TextField"
          value={userInput}
          type="text"
          onChange={(e) => {
            setUserInput(e.target.value);
          }}
          placeholder="Enter Captcha"
        />
        <Button
          sx={{
            width: "90%",
            backgroundColor: "text.primary",
            "&:hover": {
              backgroundColor: "text.secondary",
            },
          }}
          onClick={() => {
            onSubmit();
          }}
        >
          Submit
        </Button>
      </Stack>
    </Paper>
  );
}
